<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Alumni Association"
                   :links="[{title:'Home', url:'/'},{title:'Alumni Association'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Alumni Association</div>
          <blockquote class="about-message">
            <p>
              The Alumni Association of S.N.D. College of Engineering & Research Centre is constituted with the purposes
              of promoting and assisting the alumni in carrying out its charter, serving as a vehicle for the institute
              to continue to enrich the lives of its alumni. In order to strengthen the friendships established amongst
              us while at college; to continue to strengthen the attachment of each one of us to our chosen profession;
              to execute positive service to S.N.D. College of Engineering & Research Centre and society.
            </p>
            <p>
              Following activities are carried to build strong network with alumni.
            </p>
            <ul class="text-gray-500 ml-5 p-orderlist">
              <li class="p-orderlist-item">1. Interaction with students during course</li>
              <li>2. Alumni Guest Lectures</li>
              <li>3. Alumni Judges for Activities</li>
              <li>4. Alumni Meet</li>
              <li>5. Alumni referrals for Campus Placement</li>
            </ul>
          </blockquote>


        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/alumni/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "AlumniAssociation",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,

  },

}
</script>
<style lang="scss" scoped/>
